import { Injectable, Signal, signal } from '@angular/core';
import { ProviderScope, translateObjectSignal, translateSignal, TranslocoEvents, TranslocoScope, TranslocoService as TranslocoTranslateService } from '@jsverse/transloco';
// import { HashMap } from '@jsverse/transloco';
import { HashMap } from '../models/hashmap';
import { Observable } from 'rxjs';
import { TranslateService } from '../services/translate.service';
import { Translation } from '../models/translation'
;
@Injectable()
export class TranslocoService extends TranslateService {

  // activeLang: Signal<string>;
  // availableLangs: Signal<string[]>;
  events: Observable<TranslocoEvents>;

  constructor(private translocoService: TranslocoTranslateService) {
    super();
    // this.activeLang = toSignal(this.translocoService.langChanges$, { initialValue: this.translocoService.getActiveLang() });
    // this.availableLangs = signal(this.translocoService.getAvailableLangs().map(lang => typeof lang === 'string' ? lang : lang.id));
    this.events = this.translocoService.events$;
  }

  load(lang: string): Observable<Translation> {
    return this.translocoService.load(lang);
  }

  translate(key: string, params?: HashMap, lang?: string, scope?: string): string {
    const scopedKey = scope ? `${scope}.${key}` : key;
    return this.translocoService.translate(scopedKey, params, lang);
  }

  translateAsync(key: string, params?: HashMap, lang?: string, scope?: string): Observable<string> {
    const opts = this.getOpts(lang, scope);
    return this.translocoService.selectTranslate<string>(key, params, opts);
  }

  translateSignal(key: string | string[], params?: HashMap, lang?: string, scope?: string): Signal<string | string[]> {
    const opts = this.getSignalOpts(params, lang, scope);
    return translateSignal(key, opts);
  }

  translateObjectSignal(key: string, params?: HashMap, lang?: string, scope?: string): Signal<Translation> {
    const opts = this.getSignalOpts(params, lang, scope);
    return translateObjectSignal(key, opts);
  }

  selectTranslation(lang?: string): Observable<Translation> {
    return this.translocoService.selectTranslation(lang);
  }

  setActiveLang(lang: string): void {
    this.translocoService.setActiveLang(lang);
  }

  getActiveLang(): string {
    return this.translocoService.getActiveLang();
  }

  setDefaultLang(lang: string): void {
    this.translocoService.setDefaultLang(lang);
  }

  getDefaultLang(): string {
    return  this.translocoService.getDefaultLang();
  }

  setAvailableLangs(langs: string[]): void {
    this.translocoService.setAvailableLangs(langs);
  }

  getAvailableLangs(): string[] {
    return this.translocoService.getAvailableLangs().map(lang => typeof lang === 'string' ? lang : lang.id);
  }

  get langChanges(): Observable<string> {
    return this.translocoService.langChanges$;
  }

  private getOpts(lang?: string, scope?: string): TranslocoScope | undefined {
    if (scope) {
      return { scope };
    }
    if (lang) {
      return lang;
    }
    return undefined;
  }

  private getSignalOpts(params?: HashMap, lang?: string, scope?: string): { params?: HashMap; scope?: ProviderScope | string } {
    const opts: { params?: HashMap; scope?: ProviderScope | string } = {};
    if (params) {
      opts.params = params;
    }
    if (scope) {
      opts.scope = { scope };
    } else if (lang) {
      opts.scope = lang;
    }
    return opts;
  }
}